import { useState, useEffect } from "react";
// redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// mui
import { Stack, Box } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    PaginationFilter,
    LabelCard,
    LinkButton,
    ThreeDotsLoader,
    StatusFilterBox,
} from "../../components";
// icons
import { MdAdd } from "react-icons/md";
// alerts
import { errorAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";

const Areas = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(24);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [areas, setAreas] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [filterValues, setFilterValues] = useState({
        status: "",
    });
    // get all areas
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `/admin/areas?sorts=${sortValue}&page=${page}&paginate=${itemsPerPage}&filters=${filterValues.status}&q=${searchValue}`
            )
            .then((res: AxiosResponse) => {
                setAreas(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, itemsPerPage, sortValue, dataChanged, filterValues, searchValue]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة المناطق" />
            <Box>
                <LinkButton
                    text="اضافة منطقة"
                    to="/add-area"
                    icon={<MdAdd />}
                />
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            {/* area cards  */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="20px"
                flexWrap="wrap"
            >
                {loading ? (
                    <ThreeDotsLoader />
                ) : areas.length === 0 ? (
                    <p className="center-text">لا توجد عناصر لعرضها</p>
                ) : (
                    areas.map((area: any) => (
                        <LabelCard
                            key={area.id}
                            label={area.name}
                            secLabel={`${area.city.name} (${area.delivery_price})`}
                            id={area.id}
                            editPagePath={`/edit-area/${area.id}`}
                            endpointPath={`/admin/areas/${area.id}`}
                            is_disabled={area.is_disabled}
                            setDataChanged={setDataChanged}
                        />
                    ))
                )}
            </Box>
            {/* areas pagination filter  */}
            <PaginationFilter
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={page}
                setCurrentPage={setPage}
            />
        </Stack>
    );
};

export default Areas;
